import type { SignUpFormFormItem } from "./SignUpForm"

export const SIGN_UP_FORM_SUBMITTED = "SIGN_UP_FORM_SUBMITTED"
export const signUpFormSubmitted = (values: SignUpFormFormItem) => ({
    type: SIGN_UP_FORM_SUBMITTED,
    payload: {
        values: values,
    },
})

export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS"
export const signUpSuccess = (email: string, password: string) => ({
    type: SIGN_UP_SUCCESS,
    payload: {
        email: email,
        password: password,
    },
})

export const SIGN_UP_FAILURE = "SIGN_UP_FAILURE"
export const signUpFailure = (error: any) => ({
    type: SIGN_UP_FAILURE,
    payload: {
        error: error,
    },
})
